import { render, staticRenderFns } from "./expansion.vue?vue&type=template&id=af58a5ba&scoped=true&"
import script from "./expansion.vue?vue&type=script&lang=js&"
export * from "./expansion.vue?vue&type=script&lang=js&"
import style0 from "./expansion.vue?vue&type=style&index=0&id=af58a5ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af58a5ba",
  null
  
)

export default component.exports